
import { defineComponent } from "vue";
import { mapGetters } from "vuex";
export default defineComponent({
  name: "vault-tabs",
  computed: {
    ...mapGetters("auth", ["getUserPermissions"]),
    canCreateWithdrawal(): boolean {
      if (!this.getUserPermissions?.includes) return false;
      return this.getUserPermissions.includes("createWithdrawalRequest");
    },
    canApproveWithdrawals(): boolean {
      if (!this.getUserPermissions?.includes) return false;
      return this.getUserPermissions.includes("withdrawalRequestApprover");
    },
  },
});
